<template lang="pug">
  lei-modal.full-data-modal(@close="closeModal" title="All ISIN codes" size="md")
    .wrapper
      .details-table-row
        .row
          .label-block
            p.label ISIN codes
          .value-block
            .values(:style="{height: setHeight + 'px'}")
              p.value(v-for="(r, i) in fullData", :key="i") {{r}}
      t-pagination(
        v-if="showPagination"
        :current-page="pagination.currentPage",
        :last-page="pagination.lastPage",
        :per-page="getPerPage",
        @set-page="setPage",
        @next="setPage",
        @prev="setPage",
        @set-per-page="changePerPage",
        :fullDataModal="true"
        )
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState, } from 'vuex'
import LeiModal from '../lei-components/LeiModal'
import { TOGGLE_FULL_DATA_MODAL, } from '@/store/modules/record/mutations-types'
import TPagination from '../data-table/TPagination'
import { parseAllIsins, } from '../../store/modules/record/helpers/parsing'
import showCodesPerPage from '../../utils/showCodesPerPage'

export default {
  components: {
    LeiModal,
    TPagination,
  },
  computed: {
    fullData () {
      return parseAllIsins(this.isin())
    },
    pagination () {
      return this.isin().meta.pagination
    },
    getPerPage () {
      return showCodesPerPage(this.windowWidth())
    },
    showPagination () {
      return this.isin().meta.pagination.total > showCodesPerPage(this.windowWidth())
    },
    setHeight () {
      const maxCodesPerColumn = this.timelineTable().perColumn
      const codeHeight = 22
      const from = this.isin().meta.pagination.from
      const to = this.isin().meta.pagination.to
      const codesPerPage = to - from + 1
      return codesPerPage > maxCodesPerColumn ? codeHeight * maxCodesPerColumn : codeHeight * codesPerPage
    },
  },
  methods: {
    closeModal () {
      this.toggleModal({ show: false, })
    },
    changePerPage () {
      this.getISIN({
        id: this.$route.params.id,
        params: {
          page: {
            number: this.pagination.currentPage,
            size: this.getPerPage,
          },
        },
      })
    },
    setPage (val) {
      this.getISIN({
        id: this.$route.params.id,
        params: {
          page: {
            number: val,
            size: this.getPerPage,
          },
        },
      })
    },
    ...mapActions('record', [ 'getISIN', ]),
    ...mapGetters('record', [ 'isin', ]),
    ...mapState([ 'windowWidth', ]),
    ...mapState('record', [ 'timelineTable', ]),
    ...mapMutations('record', {
      toggleModal: TOGGLE_FULL_DATA_MODAL,
    }),
  },
}
</script>

<style lang="stylus">
  .full-data-modal
    .wrapper
      padding 0 20px
    .values
      display flex
      flex-wrap wrap
      flex-direction column
      line-height 22px
    .value
      width 115px
      margin-right 10px
</style>



// WEBPACK FOOTER //
// src/components/modals/FullDataModal.vue